// extracted by mini-css-extract-plugin
export var bold = "markdown-text-module--bold--bf4af";
export var caption = "markdown-text-module--caption--41ed5";
export var ctaLarge = "markdown-text-module--cta-large--30e84";
export var eyebrow = "markdown-text-module--eyebrow--116c8";
export var h1 = "markdown-text-module--h1--0daeb";
export var h1Large = "markdown-text-module--h1--large--5c8dc";
export var h2 = "markdown-text-module--h2--4ab36";
export var h3 = "markdown-text-module--h3--c1ba2";
export var h4 = "markdown-text-module--h4--84568";
export var h5 = "markdown-text-module--h5--0fa53";
export var h6 = "markdown-text-module--h6--7bcc0";
export var italic = "markdown-text-module--italic--a173e";
export var markdownImgContainer = "markdown-text-module--markdown-img-container--5f4e8";
export var markdownText = "markdown-text-module--markdown-text--2dfb5";
export var markdownTextArticle = "markdown-text-module--markdown-text--article--228d3";
export var markdownTextLegal = "markdown-text-module--markdown-text--legal--10a95";
export var markdownText__highlight = "markdown-text-module--markdown-text__highlight--f10a0";
export var mt0 = "markdown-text-module--mt-0--ce21d";
export var mt1 = "markdown-text-module--mt-1--0cb02";
export var mt2 = "markdown-text-module--mt-2--41942";
export var mt3 = "markdown-text-module--mt-3--c5143";
export var mt4 = "markdown-text-module--mt-4--fc000";
export var mt5 = "markdown-text-module--mt-5--e2298";
export var mt6 = "markdown-text-module--mt-6--7ddf4";
export var p = "markdown-text-module--p--5c99c";
export var pSmall = "markdown-text-module--p-small--ee1c6";
export var sideNavLabel = "markdown-text-module--side-nav-label--43052";
export var stat = "markdown-text-module--stat--79f2b";